import { FC } from 'react'

const UpsIcon: FC = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="20"
      height="20"
      rx="5"
      fill="white"
    />
    <g clipPath="url(#clip0_42964_865442)">
      <mask
        id="mask0_42964_865442"
        maskUnits="userSpaceOnUse"
        x="1"
        y="0"
        width="19"
        height="21"
      >
        <path
          d="M1.53906 0.591797H19.0992V20.39H1.53906V0.591797Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_42964_865442)">
        <path
          d="M10.3229 2.98047C7.8428 2.98047 5.79808 3.45218 3.99609 4.40732V11.7812C3.99609 13.3565 4.58866 14.6749 5.70976 15.5938C6.72067 16.4223 9.95605 17.8419 10.3229 18.0013C10.6896 17.8417 13.9252 16.4223 14.9361 15.5938C16.0572 14.6745 16.6497 13.3563 16.6497 11.7812V4.40766C14.8478 3.45218 12.803 2.98047 10.3229 2.98047Z"
          fill="#1E0000"
        />
      </g>
      <mask
        id="mask1_42964_865442"
        maskUnits="userSpaceOnUse"
        x="4"
        y="3"
        width="13"
        height="15"
      >
        <path
          d="M4.125 4.48297V11.779C4.125 13.314 4.70121 14.5981 5.79149 15.4916C6.78881 16.3094 9.95859 17.7004 10.3227 17.8585C10.6867 17.7004 13.8566 16.3094 14.8539 15.4918C15.9442 14.5983 16.5204 13.314 16.5204 11.7792V4.48297C14.7988 3.57001 12.7135 3.10742 10.3227 3.10742C7.93194 3.10742 5.84693 3.57018 4.125 4.48331"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_42964_865442)">
        <path
          d="M4.125 3.1084H16.5204V17.8589H4.125V3.1084Z"
          fill="url(#paint0_radial_42964_865442)"
        />
      </g>
      <mask
        id="mask2_42964_865442"
        maskUnits="userSpaceOnUse"
        x="1"
        y="0"
        width="19"
        height="21"
      >
        <path
          d="M1.53906 0.591797H19.0992V20.39H1.53906V0.591797Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2_42964_865442)">
        <path
          d="M14.2775 17.0221V17.6552H14.3918V17.3911H14.4081C14.4167 17.4038 14.5803 17.6552 14.5803 17.6552H14.7185L14.5279 17.3763C14.6116 17.3566 14.6681 17.2959 14.6681 17.2081C14.6681 17.1182 14.6127 17.0221 14.4572 17.0221H14.2775ZM14.4439 17.1146C14.5409 17.1146 14.5538 17.1621 14.5538 17.2034C14.5538 17.2632 14.5283 17.3028 14.4057 17.3028H14.3919V17.1146H14.4439ZM14.891 17.3405C14.891 17.576 14.6992 17.7681 14.4618 17.7681C14.2255 17.7681 14.0332 17.576 14.0332 17.3405C14.0332 17.1043 14.2255 16.9109 14.4618 16.9109C14.6991 16.9109 14.8909 17.1044 14.8909 17.3406M14.4613 16.8193C14.1747 16.8193 13.9414 17.054 13.9414 17.3406C13.9414 17.6273 14.1747 17.8606 14.4613 17.8606C14.7497 17.8606 14.9823 17.6273 14.9823 17.3406C14.9823 17.054 14.7499 16.8193 14.4613 16.8193Z"
          fill="#C86E14"
        />
      </g>
      <mask
        id="mask3_42964_865442"
        maskUnits="userSpaceOnUse"
        x="4"
        y="4"
        width="12"
        height="14"
      >
        <path
          d="M10.1065 8.79256V12.1056C10.1836 12.1343 10.3101 12.1707 10.4563 12.1707C11.0771 12.1707 11.3732 11.6012 11.3732 10.4224C11.3732 9.21435 11.1141 8.71492 10.4883 8.71492C10.342 8.71492 10.1939 8.74935 10.1065 8.79239M7.39791 12.0198V7.95587H8.47425V12.6334C8.06227 12.9133 7.50947 13.0666 6.84959 13.0666C5.78255 13.0666 5.24162 12.4878 5.24162 11.345V7.95587H6.31934V11.393C6.31934 11.6989 6.39337 12.1517 6.88746 12.1517C7.10662 12.1517 7.2805 12.1006 7.39774 12.0198M9.02739 8.23012C9.41854 7.97774 9.89283 7.84655 10.4809 7.84655C11.768 7.84655 12.4752 8.82303 12.4752 10.395C12.4752 11.9699 11.7883 13.048 10.5915 13.048C10.3702 13.048 10.2139 13.0187 10.1063 12.9869V15.2571H9.02739V8.23029V8.23012ZM14.4435 11.5769C14.4356 11.2382 14.2443 11.0547 13.7704 10.7763C12.881 10.2544 12.7212 9.82534 12.7197 9.25171C12.715 8.38059 13.4569 7.86721 14.1663 7.84655C14.7585 7.82847 15.1597 8.0509 15.3494 8.19672V9.1343C15.1247 8.9036 14.7603 8.6946 14.3836 8.69116C14.0782 8.68841 13.76 8.82286 13.7494 9.20643C13.739 9.59861 14.0563 9.7539 14.4586 9.98941C15.3594 10.519 15.5336 10.9948 15.5129 11.6239C15.4923 12.3132 15.0171 13.0666 13.9518 13.0666C13.5255 13.0666 13.1041 12.9333 12.7665 12.7317V11.7389C13.042 11.9842 13.4534 12.1751 13.7974 12.1775H13.8017C14.1949 12.1775 14.4531 11.9515 14.4438 11.5767M4.69158 7.60639V11.7795C4.69158 13.1389 5.19428 14.2741 6.14942 15.0522C6.99248 15.7392 9.58777 16.9133 10.3196 17.2369C11.042 16.9184 13.6307 15.7588 14.4888 15.0522C15.4503 14.2603 15.9478 13.1516 15.9478 11.7795V4.63666C15.1824 4.56538 14.3874 4.51855 13.5772 4.51855C10.5735 4.51855 7.35367 5.16415 4.69141 7.60605"
          fill="white"
        />
      </mask>
      <g mask="url(#mask3_42964_865442)">
        <path
          d="M4.69141 4.51855H15.9478V17.2369H4.69141V4.51855Z"
          fill="url(#paint1_radial_42964_865442)"
        />
      </g>
      <mask
        id="mask4_42964_865442"
        maskUnits="userSpaceOnUse"
        x="4"
        y="11"
        width="7"
        height="7"
      >
        <path
          d="M4.69158 11.7793C4.69158 13.1387 5.19428 14.2739 6.14942 15.052C6.99265 15.7389 9.58794 16.9131 10.3198 17.2367V17.1518C9.71207 16.8829 7.05187 15.6876 6.19831 14.9919C5.26332 14.2301 4.76888 13.1192 4.76888 11.7793H4.69141H4.69158Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask4_42964_865442)">
        <path
          d="M7.60424 20.0488L1.96484 14.6029L7.40781 8.9668L13.047 14.4125"
          fill="url(#paint2_linear_42964_865442)"
        />
      </g>
      <mask
        id="mask5_42964_865442"
        maskUnits="userSpaceOnUse"
        x="10"
        y="11"
        width="6"
        height="7"
      >
        <path
          d="M15.8671 11.7793C15.8671 13.129 15.3858 14.2102 14.4362 14.9921C13.6105 15.6721 11.1145 16.7998 10.3164 17.1518V17.2365C11.0386 16.9181 13.6274 15.7584 14.4854 15.0519C15.4471 14.2601 15.9446 13.1514 15.9446 11.7793H15.8671Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask5_42964_865442)">
        <path
          d="M7.59375 14.4125L13.233 8.9668L18.6759 14.6029L13.0365 20.0488"
          fill="url(#paint3_linear_42964_865442)"
        />
      </g>
      <mask
        id="mask6_42964_865442"
        maskUnits="userSpaceOnUse"
        x="4"
        y="4"
        width="12"
        height="4"
      >
        <path
          d="M4.69141 7.60605L4.76888 7.64013C7.01555 5.59214 9.89696 4.59603 13.5772 4.59603C14.2958 4.59603 15.0467 4.63252 15.8703 4.70724L15.9478 4.63666C15.1824 4.56538 14.3874 4.51855 13.5772 4.51855C10.5735 4.51855 7.35367 5.16415 4.69141 7.60605Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask6_42964_865442)">
        <path
          d="M3.72266 4.85689L14.731 1.02344L16.9177 7.30326L5.90959 11.1369"
          fill="url(#paint4_linear_42964_865442)"
        />
      </g>
      <mask
        id="mask7_42964_865442"
        maskUnits="userSpaceOnUse"
        x="10"
        y="10"
        width="2"
        height="3"
      >
        <path
          d="M11.3004 10.4238C11.3004 11.3767 11.1127 12.0948 10.4609 12.0948V12.1723C11.0817 12.1723 11.3779 11.6024 11.3779 10.4238H11.3004Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask7_42964_865442)">
        <path
          d="M9.76172 11.8201L10.6483 10.0566L12.0821 10.7775L11.1955 12.5409"
          fill="url(#paint5_linear_42964_865442)"
        />
      </g>
      <mask
        id="mask8_42964_865442"
        maskUnits="userSpaceOnUse"
        x="10"
        y="12"
        width="1"
        height="1"
      >
        <path
          d="M10.1094 12.1062C10.1865 12.135 10.313 12.1713 10.4592 12.1713V12.0938C10.3532 12.0938 10.2581 12.0732 10.1868 12.0508L10.1094 12.1062Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask8_42964_865442)">
        <path
          d="M10.453 12.213L10.0938 12.169L10.1135 12.0078L10.4728 12.0519"
          fill="url(#paint6_linear_42964_865442)"
        />
      </g>
      <mask
        id="mask9_42964_865442"
        maskUnits="userSpaceOnUse"
        x="10"
        y="8"
        width="1"
        height="1"
      >
        <path
          d="M10.1094 8.79346L10.1868 8.84459C10.2619 8.81705 10.3738 8.79329 10.4916 8.79329V8.71582C10.3452 8.71582 10.1968 8.75025 10.1094 8.79329"
          fill="white"
        />
      </mask>
      <g mask="url(#mask9_42964_865442)">
        <path
          d="M10.0742 8.72416L10.463 8.62207L10.5192 8.83641L10.1302 8.93798"
          fill="url(#paint7_linear_42964_865442)"
        />
      </g>
      <mask
        id="mask10_42964_865442"
        maskUnits="userSpaceOnUse"
        x="10"
        y="8"
        width="2"
        height="3"
      >
        <path
          d="M10.4922 8.79346C11.1278 8.79346 11.2996 9.38741 11.2996 10.4233H11.3771C11.3771 9.21525 11.1178 8.71582 10.4922 8.71582V8.79329V8.79346Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask10_42964_865442)">
        <path
          d="M10.6746 10.7798L9.80469 9.06511L11.1971 8.3584L12.0674 10.0734"
          fill="url(#paint8_linear_42964_865442)"
        />
      </g>
      <mask
        id="mask11_42964_865442"
        maskUnits="userSpaceOnUse"
        x="12"
        y="7"
        width="3"
        height="3"
      >
        <path
          d="M12.6564 9.25365L12.7339 9.25314C12.7293 8.38202 13.4711 7.86864 14.1806 7.84798L14.1782 7.77051C13.3941 7.7934 12.6516 8.36704 12.6563 9.25348"
          fill="white"
        />
      </mask>
      <g mask="url(#mask11_42964_865442)">
        <path
          d="M14.9147 8.58674L13.3351 10.0139L11.9102 8.43696L13.4897 7.00977"
          fill="url(#paint9_linear_42964_865442)"
        />
      </g>
      <mask
        id="mask12_42964_865442"
        maskUnits="userSpaceOnUse"
        x="13"
        y="8"
        width="2"
        height="2"
      >
        <path
          d="M13.7539 9.2065L13.8314 9.20823C13.8341 9.10493 13.882 8.76853 14.3775 8.76853L14.3881 8.69141H14.3787C14.0764 8.69141 13.7644 8.82707 13.7541 9.20668"
          fill="white"
        />
      </mask>
      <g mask="url(#mask12_42964_865442)">
        <path
          d="M13.4961 8.91455L14.1133 8.37793L14.6423 8.98651L14.025 9.52313"
          fill="url(#paint10_linear_42964_865442)"
        />
      </g>
      <mask
        id="mask13_42964_865442"
        maskUnits="userSpaceOnUse"
        x="14"
        y="8"
        width="2"
        height="2"
      >
        <path
          d="M14.3828 8.76853C14.8287 8.76853 15.2095 9.05862 15.4368 9.32512L15.3593 9.13454C15.1346 8.90385 14.7702 8.69485 14.3935 8.69141L14.3828 8.76888V8.76853Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask13_42964_865442)">
        <path
          d="M15.2098 9.75668L14.1211 9.18994L14.6055 8.25977L15.6943 8.82651"
          fill="url(#paint11_linear_42964_865442)"
        />
      </g>
      <mask
        id="mask14_42964_865442"
        maskUnits="userSpaceOnUse"
        x="14"
        y="7"
        width="2"
        height="2"
      >
        <path
          d="M14.1719 7.76993L14.1743 7.8474C14.7665 7.82933 15.1676 8.05176 15.3574 8.19757L15.4348 8.15935C15.2723 8.02765 14.859 7.76855 14.24 7.76855C14.2177 7.76855 14.1948 7.76907 14.1719 7.76976"
          fill="white"
        />
      </mask>
      <g mask="url(#mask14_42964_865442)">
        <path
          d="M14.2913 7.39844L15.5605 7.80817L15.3157 8.56567L14.0469 8.15593"
          fill="url(#paint12_linear_42964_865442)"
        />
      </g>
      <mask
        id="mask15_42964_865442"
        maskUnits="userSpaceOnUse"
        x="13"
        y="11"
        width="3"
        height="3"
      >
        <path
          d="M13.9492 13.0695V13.1469C14.9266 13.1469 15.5618 12.4962 15.5882 11.6297L15.5107 11.627C15.49 12.3163 15.0144 13.0696 13.9492 13.0696"
          fill="white"
        />
      </mask>
      <g mask="url(#mask15_42964_865442)">
        <path
          d="M16.3534 12.4027L14.7575 13.9659L13.1953 12.3708L14.7916 10.8076"
          fill="url(#paint13_linear_42964_865442)"
        />
      </g>
      <mask
        id="mask16_42964_865442"
        maskUnits="userSpaceOnUse"
        x="12"
        y="12"
        width="2"
        height="2"
      >
        <path
          d="M12.6953 12.7773C13.0809 13.0075 13.4952 13.1457 13.9581 13.1457V13.0682C13.5318 13.0682 13.1104 12.935 12.7728 12.7334L12.6953 12.7773Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask16_42964_865442)">
        <path
          d="M12.7891 12.3965L14.0648 12.7649L13.8577 13.4818L12.582 13.1137"
          fill="url(#paint14_linear_42964_865442)"
        />
      </g>
      <mask
        id="mask17_42964_865442"
        maskUnits="userSpaceOnUse"
        x="12"
        y="11"
        width="2"
        height="2"
      >
        <path
          d="M12.773 11.7412C13.0481 11.9865 13.4599 12.1775 13.8037 12.1799L13.804 12.1024C13.4201 12.0996 12.9766 11.8528 12.6953 11.5684L12.7728 11.7414L12.773 11.7412Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask17_42964_865442)">
        <path
          d="M13.5947 12.6148L12.457 12.0622L12.9089 11.1318L14.0466 11.6841"
          fill="url(#paint15_linear_42964_865442)"
        />
      </g>
      <mask
        id="mask18_42964_865442"
        maskUnits="userSpaceOnUse"
        x="13"
        y="11"
        width="2"
        height="2"
      >
        <path
          d="M14.3698 11.5802C14.3784 11.9242 14.1377 12.1039 13.8013 12.1015L13.8008 12.179C14.1961 12.1807 14.4564 11.9541 14.4471 11.5781L14.3696 11.5802H14.3698Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask18_42964_865442)">
        <path
          d="M13.5039 11.8545L14.1593 11.252L14.7598 11.905L14.1046 12.5075"
          fill="url(#paint16_linear_42964_865442)"
        />
      </g>
      <mask
        id="mask19_42964_865442"
        maskUnits="userSpaceOnUse"
        x="12"
        y="9"
        width="3"
        height="3"
      >
        <path
          d="M12.6562 9.25442C12.658 9.85835 12.8367 10.3122 13.745 10.8452C14.2308 11.1306 14.3734 11.2957 14.3802 11.5811L14.4577 11.5794C14.4495 11.2403 14.258 11.0569 13.7841 10.7784C12.895 10.2567 12.7353 9.82754 12.7339 9.25391L12.6564 9.25425L12.6562 9.25442Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask19_42964_865442)">
        <path
          d="M13.868 8.4082L15.5454 10.8219L13.2398 12.4238L11.5625 10.0105"
          fill="url(#paint17_linear_42964_865442)"
        />
      </g>
      <mask
        id="mask20_42964_865442"
        maskUnits="userSpaceOnUse"
        x="13"
        y="9"
        width="3"
        height="3"
      >
        <path
          d="M14.4636 9.99081C15.364 10.5204 15.5384 10.9962 15.5178 11.6253L15.5952 11.628C15.6164 10.9852 15.441 10.4758 14.5027 9.92419C14.1216 9.69315 13.822 9.5673 13.8316 9.20973L13.7542 9.20801C13.7435 9.60001 14.061 9.75513 14.4635 9.99081"
          fill="white"
        />
      </mask>
      <g mask="url(#mask20_42964_865442)">
        <path
          d="M14.9666 8.31543L16.7732 10.7842L14.4004 12.5206L12.5938 10.0522"
          fill="url(#paint18_linear_42964_865442)"
        />
      </g>
      <mask
        id="mask21_42964_865442"
        maskUnits="userSpaceOnUse"
        x="1"
        y="0"
        width="19"
        height="21"
      >
        <path
          d="M1.53516 0.59082H19.0953V20.3891H1.53516V0.59082Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask21_42964_865442)">
        <path
          d="M10.1054 15.2578H9.02669L8.94922 15.3353H10.1827"
          fill="#8F4A02"
        />
      </g>
      <mask
        id="mask22_42964_865442"
        maskUnits="userSpaceOnUse"
        x="10"
        y="12"
        width="1"
        height="2"
      >
        <path
          d="M10.1868 13.0865C10.3086 13.1126 10.4451 13.1261 10.5945 13.1261V13.0486C10.3733 13.0486 10.217 13.019 10.1094 12.9873L10.1868 13.0866V13.0865Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask22_42964_865442)">
        <path
          d="M10.1222 12.9141L10.617 12.9907L10.5846 13.1995L10.0898 13.1229"
          fill="url(#paint19_linear_42964_865442)"
        />
      </g>
      <mask
        id="mask23_42964_865442"
        maskUnits="userSpaceOnUse"
        x="10"
        y="10"
        width="3"
        height="4"
      >
        <path
          d="M12.4775 10.3945C12.4775 11.9694 11.7906 13.0475 10.5938 13.0475V13.125C11.9831 13.125 12.555 11.7976 12.555 10.3945H12.4775Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask23_42964_865442)">
        <path
          d="M13.8507 11.3204L11.8933 14.0538L9.30469 12.2005L11.2618 9.4668"
          fill="url(#paint20_linear_42964_865442)"
        />
      </g>
      <mask
        id="mask24_42964_865442"
        maskUnits="userSpaceOnUse"
        x="8"
        y="7"
        width="3"
        height="2"
      >
        <path
          d="M8.95703 8.1892L9.0345 8.23155C9.42565 7.97916 9.89994 7.84798 10.488 7.84798V7.77051C9.89065 7.77051 9.37073 7.90737 8.95703 8.1892Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask24_42964_865442)">
        <path
          d="M10.5982 8.20271L9.05137 8.60297L8.84375 7.79951L10.3906 7.39941"
          fill="url(#paint21_linear_42964_865442)"
        />
      </g>
      <mask
        id="mask25_42964_865442"
        maskUnits="userSpaceOnUse"
        x="10"
        y="7"
        width="3"
        height="4"
      >
        <path
          d="M10.4883 7.84798C11.7753 7.84798 12.4826 8.82446 12.4826 10.3964H12.56C12.56 9.00575 11.9781 7.77051 10.4885 7.77051V7.84798H10.4883Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask25_42964_865442)">
        <path
          d="M11.7731 6.76465L13.8364 9.39661L11.2787 11.4023L9.21484 8.77047"
          fill="url(#paint22_linear_42964_865442)"
        />
      </g>
      <mask
        id="mask26_42964_865442"
        maskUnits="userSpaceOnUse"
        x="1"
        y="0"
        width="19"
        height="21"
      >
        <path
          d="M1.53516 0.59082H19.0953V20.3891H1.53516V0.59082Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask26_42964_865442)">
        <path
          d="M6.31959 7.95735H5.24153L5.16406 7.87988H6.39672L6.31959 7.95735ZM8.47433 7.95735H7.39799L7.32052 7.87988H8.5518L8.47433 7.95735Z"
          fill="#FFC20E"
        />
      </g>
      <mask
        id="mask27_42964_865442"
        maskUnits="userSpaceOnUse"
        x="1"
        y="0"
        width="19"
        height="21"
      >
        <path
          d="M1.53516 0.59082H19.0953V20.3891H1.53516V0.59082Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask27_42964_865442)">
        <path
          d="M4.69141 11.7803V7.60645L4.76888 7.64053V11.7797H4.69141V11.7803ZM15.4272 9.32579V8.15925L15.3497 8.19747V9.13487L15.4272 9.32579ZM6.39664 11.3938V7.87914L6.31917 7.95662V11.3936L6.39664 11.3938Z"
          fill="#D78817"
        />
      </g>
      <mask
        id="mask28_42964_865442"
        maskUnits="userSpaceOnUse"
        x="1"
        y="0"
        width="19"
        height="21"
      >
        <path
          d="M1.53516 0.59082H19.0953V20.3891H1.53516V0.59082Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask28_42964_865442)">
        <path
          d="M15.8701 11.7806V4.70828L15.9476 4.6377V11.7806H15.8701ZM12.6889 11.5671V12.7767L12.7664 12.7328V11.7401L12.6889 11.5674V11.5671ZM7.39765 12.0209V7.95691L7.32018 7.87944V11.9785L7.39765 12.0209ZM5.24153 11.346V7.95691L5.16406 7.87944V11.3462L5.24153 11.346Z"
          fill="#D89016"
        />
      </g>
      <mask
        id="mask29_42964_865442"
        maskUnits="userSpaceOnUse"
        x="5"
        y="11"
        width="2"
        height="3"
      >
        <path
          d="M5.16797 11.3447C5.16797 12.4861 5.70304 13.1438 6.8534 13.1438V13.0663C5.78636 13.0663 5.24544 12.4875 5.24544 11.3447H5.16797Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask29_42964_865442)">
        <path
          d="M6.07134 10.5049L7.74937 12.3108L5.94773 13.9849L4.26953 12.179"
          fill="url(#paint23_linear_42964_865442)"
        />
      </g>
      <mask
        id="mask30_42964_865442"
        maskUnits="userSpaceOnUse"
        x="6"
        y="12"
        width="3"
        height="2"
      >
        <path
          d="M6.85564 13.0671V13.1446C7.54427 13.1446 8.10069 12.9855 8.5576 12.6751L8.48013 12.6338C8.06815 12.9137 7.51535 13.0669 6.85547 13.0669"
          fill="white"
        />
      </mask>
      <g mask="url(#mask30_42964_865442)">
        <path
          d="M8.68407 13.1118L6.96507 13.5563L6.73438 12.6652L8.45355 12.2207"
          fill="url(#paint24_linear_42964_865442)"
        />
      </g>
      <mask
        id="mask31_42964_865442"
        maskUnits="userSpaceOnUse"
        x="6"
        y="11"
        width="2"
        height="2"
      >
        <path
          d="M6.89453 12.0769V12.1544C7.11352 12.1544 7.2874 12.1033 7.40464 12.0225L7.32717 11.9795C7.21767 12.0427 7.066 12.0769 6.89453 12.0769Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask31_42964_865442)">
        <path
          d="M6.85547 11.9894L7.37676 11.8613L7.44632 12.144L6.92468 12.2723"
          fill="url(#paint25_linear_42964_865442)"
        />
      </g>
      <mask
        id="mask32_42964_865442"
        maskUnits="userSpaceOnUse"
        x="6"
        y="11"
        width="1"
        height="2"
      >
        <path
          d="M6.3125 11.3936C6.3125 11.6995 6.38653 12.1523 6.88062 12.1523V12.0748C6.50067 12.0748 6.38997 11.7683 6.38997 11.3936H6.3125Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask32_42964_865442)">
        <path
          d="M6.51298 12.4234L5.95312 11.6585L6.6848 11.123L7.24466 11.8879"
          fill="url(#paint26_linear_42964_865442)"
        />
      </g>
      <mask
        id="mask33_42964_865442"
        maskUnits="userSpaceOnUse"
        x="1"
        y="0"
        width="19"
        height="21"
      >
        <path
          d="M1.53516 0.59082H19.0953V20.3891H1.53516V0.59082Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask33_42964_865442)">
        <path
          d="M8.94922 8.18848V15.3353L9.02669 15.2578V8.23083"
          fill="#D78817"
        />
      </g>
      <mask
        id="mask34_42964_865442"
        maskUnits="userSpaceOnUse"
        x="1"
        y="0"
        width="19"
        height="21"
      >
        <path
          d="M1.53516 0.59082H19.0953V20.3891H1.53516V0.59082Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask34_42964_865442)">
        <path
          d="M10.1822 12.0516V8.845L10.1047 8.79387V12.1067L10.1822 12.0516ZM10.1822 13.088V15.3364L10.1047 15.2589V12.9882L10.1822 13.088ZM8.55013 12.6762V7.87988L8.47266 7.95735V12.6349"
          fill="#BF7312"
        />
      </g>
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_42964_865442"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(6.01964 5.65749) rotate(90) scale(20.5915 10.2958)"
      >
        <stop stopColor="#FFDC00" />
        <stop
          offset="0.35"
          stopColor="#FFBE00"
        />
        <stop
          offset="1"
          stopColor="#C86E14"
        />
      </radialGradient>
      <radialGradient
        id="paint1_radial_42964_865442"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(6.02272 5.66822) rotate(90) scale(20.4323 10.2162)"
      >
        <stop stopColor="#4B3333" />
        <stop
          offset="0.35"
          stopColor="#351A1A"
        />
        <stop
          offset="0.85"
          stopColor="#1E0000"
        />
        <stop
          offset="1"
          stopColor="#1E0000"
        />
      </radialGradient>
      <linearGradient
        id="paint2_linear_42964_865442"
        x1="1109.52"
        y1="-1121.01"
        x2="1103.88"
        y2="-1126.46"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E49F15" />
        <stop
          offset="0.024"
          stopColor="#E39C15"
        />
        <stop
          offset="0.178"
          stopColor="#DC9116"
        />
        <stop
          offset="0.396"
          stopColor="#D88A17"
        />
        <stop
          offset="1"
          stopColor="#D78817"
        />
      </linearGradient>
      <linearGradient
        id="paint3_linear_42964_865442"
        x1="1111.29"
        y1="1157.33"
        x2="1116.93"
        y2="1151.88"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFC20E" />
        <stop
          offset="1"
          stopColor="#D89016"
        />
      </linearGradient>
      <linearGradient
        id="paint4_linear_42964_865442"
        x1="775.643"
        y1="2221.47"
        x2="786.604"
        y2="2217.65"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E49F15" />
        <stop
          offset="0.975"
          stopColor="#8F4A02"
        />
        <stop
          offset="1"
          stopColor="#8F4A02"
        />
      </linearGradient>
      <linearGradient
        id="paint5_linear_42964_865442"
        x1="366.997"
        y1="191.489"
        x2="367.884"
        y2="189.725"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFC20E" />
        <stop
          offset="0.05"
          stopColor="#FFC20E"
        />
        <stop
          offset="0.95"
          stopColor="#BF7312"
        />
        <stop
          offset="1"
          stopColor="#BF7312"
        />
      </linearGradient>
      <linearGradient
        id="paint6_linear_42964_865442"
        x1="19.2116"
        y1="-59.1148"
        x2="18.8589"
        y2="-59.1581"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFC20E" />
        <stop
          offset="0.05"
          stopColor="#FFC20E"
        />
        <stop
          offset="0.95"
          stopColor="#F0AF13"
        />
        <stop
          offset="1"
          stopColor="#F0AF13"
        />
      </linearGradient>
      <linearGradient
        id="paint7_linear_42964_865442"
        x1="30.0631"
        y1="84.8661"
        x2="30.4395"
        y2="84.7674"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A65E0C" />
        <stop
          offset="0.05"
          stopColor="#A65E0C"
        />
        <stop
          offset="0.95"
          stopColor="#8F4A02"
        />
        <stop
          offset="1"
          stopColor="#8F4A02"
        />
      </linearGradient>
      <linearGradient
        id="paint8_linear_42964_865442"
        x1="358.147"
        y1="-165.503"
        x2="357.276"
        y2="-167.218"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BF7312" />
        <stop
          offset="0.05"
          stopColor="#BF7312"
        />
        <stop
          offset="0.95"
          stopColor="#8F4A02"
        />
        <stop
          offset="1"
          stopColor="#8F4A02"
        />
      </linearGradient>
      <linearGradient
        id="paint9_linear_42964_865442"
        x1="-273.603"
        y1="-310.725"
        x2="-275.179"
        y2="-309.301"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFC20E" />
        <stop
          offset="0.05"
          stopColor="#FFC20E"
        />
        <stop
          offset="0.95"
          stopColor="#D89016"
        />
        <stop
          offset="1"
          stopColor="#D89016"
        />
      </linearGradient>
      <linearGradient
        id="paint10_linear_42964_865442"
        x1="121.907"
        y1="133.625"
        x2="122.523"
        y2="133.09"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D78817" />
        <stop
          offset="0.05"
          stopColor="#D78817"
        />
        <stop
          offset="0.95"
          stopColor="#8F4A02"
        />
        <stop
          offset="1"
          stopColor="#8F4A02"
        />
      </linearGradient>
      <linearGradient
        id="paint11_linear_42964_865442"
        x1="129.138"
        y1="-209.095"
        x2="128.058"
        y2="-209.658"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BF7312" />
        <stop
          offset="0.95"
          stopColor="#8F4A02"
        />
        <stop
          offset="1"
          stopColor="#8F4A02"
        />
      </linearGradient>
      <linearGradient
        id="paint12_linear_42964_865442"
        x1="-67.863"
        y1="261.748"
        x2="-66.6055"
        y2="262.154"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFC20E" />
        <stop
          offset="0.05"
          stopColor="#FFC20E"
        />
        <stop
          offset="0.95"
          stopColor="#E49F15"
        />
        <stop
          offset="1"
          stopColor="#E49F15"
        />
      </linearGradient>
      <linearGradient
        id="paint13_linear_42964_865442"
        x1="15.5711"
        y1="11.6024"
        x2="13.9745"
        y2="13.166"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D78817" />
        <stop
          offset="0.05"
          stopColor="#D78817"
        />
        <stop
          offset="0.95"
          stopColor="#8F4A02"
        />
        <stop
          offset="1"
          stopColor="#8F4A02"
        />
      </linearGradient>
      <linearGradient
        id="paint14_linear_42964_865442"
        x1="12.6988"
        y1="12.7591"
        x2="13.9626"
        y2="13.1239"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BF7312" />
        <stop
          offset="0.95"
          stopColor="#8F4A02"
        />
        <stop
          offset="1"
          stopColor="#8F4A02"
        />
      </linearGradient>
      <linearGradient
        id="paint15_linear_42964_865442"
        x1="125.296"
        y1="-217.426"
        x2="124.159"
        y2="-217.978"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFC20E" />
        <stop
          offset="0.05"
          stopColor="#FFC20E"
        />
        <stop
          offset="1"
          stopColor="#F0AF13"
        />
      </linearGradient>
      <linearGradient
        id="paint16_linear_42964_865442"
        x1="134.572"
        y1="143.515"
        x2="135.221"
        y2="142.918"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFC20E" />
        <stop
          offset="0.05"
          stopColor="#FFC20E"
        />
        <stop
          offset="0.95"
          stopColor="#D89016"
        />
        <stop
          offset="1"
          stopColor="#D89016"
        />
      </linearGradient>
      <linearGradient
        id="paint17_linear_42964_865442"
        x1="-474.641"
        y1="347.93"
        x2="-472.962"
        y2="350.346"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D89016" />
        <stop
          offset="0.4"
          stopColor="#BF7312"
        />
        <stop
          offset="0.6"
          stopColor="#BF7312"
        />
        <stop
          offset="1"
          stopColor="#D89016"
        />
      </linearGradient>
      <linearGradient
        id="paint18_linear_42964_865442"
        x1="-481.607"
        y1="371.762"
        x2="-479.812"
        y2="374.215"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D78817" />
        <stop
          offset="0.4"
          stopColor="#E49F15"
        />
        <stop
          offset="0.6"
          stopColor="#E49F15"
        />
        <stop
          offset="1"
          stopColor="#D78817"
        />
      </linearGradient>
      <linearGradient
        id="paint19_linear_42964_865442"
        x1="10.1073"
        y1="13.0208"
        x2="10.6026"
        y2="13.0975"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A65E0C" />
        <stop
          offset="0.05"
          stopColor="#A65E0C"
        />
        <stop
          offset="0.95"
          stopColor="#8F4A02"
        />
        <stop
          offset="1"
          stopColor="#8F4A02"
        />
      </linearGradient>
      <linearGradient
        id="paint20_linear_42964_865442"
        x1="-539.113"
        y1="-384.557"
        x2="-541.07"
        y2="-381.824"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A65E0C" />
        <stop
          offset="0.05"
          stopColor="#A65E0C"
        />
        <stop
          offset="0.95"
          stopColor="#8F4A02"
        />
        <stop
          offset="1"
          stopColor="#8F4A02"
        />
      </linearGradient>
      <linearGradient
        id="paint21_linear_42964_865442"
        x1="-69.7954"
        y1="-302.655"
        x2="-71.3319"
        y2="-302.258"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFC20E" />
        <stop
          offset="0.05"
          stopColor="#FFC20E"
        />
        <stop
          offset="0.95"
          stopColor="#F0AF13"
        />
        <stop
          offset="1"
          stopColor="#F0AF13"
        />
      </linearGradient>
      <linearGradient
        id="paint22_linear_42964_865442"
        x1="-520.643"
        y1="424.235"
        x2="-518.579"
        y2="426.867"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFC20E" />
        <stop
          offset="0.05"
          stopColor="#FFC20E"
        />
        <stop
          offset="0.95"
          stopColor="#A65E0C"
        />
        <stop
          offset="1"
          stopColor="#A65E0C"
        />
      </linearGradient>
      <linearGradient
        id="paint23_linear_42964_865442"
        x1="-360.023"
        y1="350.696"
        x2="-358.343"
        y2="352.504"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D89016" />
        <stop
          offset="0.05"
          stopColor="#D89016"
        />
        <stop
          offset="0.95"
          stopColor="#8F4A02"
        />
        <stop
          offset="1"
          stopColor="#8F4A02"
        />
      </linearGradient>
      <linearGradient
        id="paint24_linear_42964_865442"
        x1="8.56063"
        y1="12.6698"
        x2="6.85144"
        y2="13.1119"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A65E0C" />
        <stop
          offset="0.05"
          stopColor="#A65E0C"
        />
        <stop
          offset="0.95"
          stopColor="#8F4A02"
        />
        <stop
          offset="1"
          stopColor="#8F4A02"
        />
      </linearGradient>
      <linearGradient
        id="paint25_linear_42964_865442"
        x1="6.88749"
        y1="12.1313"
        x2="7.39906"
        y2="12.0056"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFC20E" />
        <stop
          offset="0.05"
          stopColor="#FFC20E"
        />
        <stop
          offset="0.95"
          stopColor="#F0AF13"
        />
        <stop
          offset="1"
          stopColor="#F0AF13"
        />
      </linearGradient>
      <linearGradient
        id="paint26_linear_42964_865442"
        x1="161.265"
        y1="-100.838"
        x2="160.705"
        y2="-101.603"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFC20E" />
        <stop
          offset="0.05"
          stopColor="#FFC20E"
        />
        <stop
          offset="0.95"
          stopColor="#D78817"
        />
        <stop
          offset="1"
          stopColor="#D78817"
        />
      </linearGradient>
      <clipPath id="clip0_42964_865442">
        <rect
          width="12.6499"
          height="15"
          fill="white"
          transform="translate(4 3)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default UpsIcon
